/**
 * Extends useListState from @react-stately/list
 * https://github.com/adobe/react-spectrum/blob/main/packages/%40react-stately/list/src/useListState.ts
 *
 * Added support for `isDisabled` prop.
 *
 */
import {
  ListProps,
  ListState,
  useListState as originalUseListState,
} from 'react-stately/useListState';
import { Key } from 'react';

export function useListState<T extends object>(
  props: ListProps<T> & { isDisabled?: boolean }
): ListState<T> {
  const state = originalUseListState(props);

  const disabledKeys = props.isDisabled
    ? new Set(state.collection.getKeys())
    : state.disabledKeys;

  state.selectionManager.isDisabled = (key: Key) => {
    if (props.isDisabled) {
      return true;
    }
    return state.disabledKeys.has(key);
  };

  return {
    collection: state.collection,
    disabledKeys,
    selectionManager: state.selectionManager,
  };
}
